"use client";

import { usePathname } from "next/navigation";
import { useNavigationStore } from "@/store/navigation/navigation-store";

export default function NavigationLoadingLayer() {
  const pathname = usePathname();
  const isNavigating = useNavigationStore((state) => state.isNavigating);
  const targetHref = useNavigationStore((state) => state.targetHref);

  const isDedicatedAiProcessingTransition =
    (pathname?.includes("/connectors/add-api") &&
      targetHref?.includes("/connectors/add-api/review")) ||
    (pathname?.includes("/specs/actions/new") &&
      targetHref?.includes("/specs/actions/new/review"));

  if (!isNavigating || isDedicatedAiProcessingTransition) {
    return null;
  }

  return (
    <div
      data-testid="div-navigation-loading-layer"
      className="fixed inset-0 z-[70] flex items-center justify-center bg-white"
    >
      <div className="flex items-center justify-center">
        <div
          className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"
          role="status"
          aria-label="Loading"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
}
